var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlogView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #042b62;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M550.69,39.38h0c280.73,0,508.31,227.58,508.31,508.31h0c0,280.73-227.58,508.31-508.31,508.31h0c-280.73,0-508.31-227.58-508.31-508.31h0c0-280.73,227.58-508.31,508.31-508.31Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M822.82,565.67c9.92-9.93,9.92-26.02,0-35.95l-161.74-161.74c-9.93-9.93-26.02-9.93-35.94,0-9.93,9.93-9.93,26.02,0,35.94l143.77,143.77-143.77,143.77c-9.93,9.93-9.93,26.02,0,35.94,9.92,9.93,26.02,9.93,35.94,0l161.74-161.74ZM296.54,573.11h508.31v-50.83h-508.31v50.83Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogView);
export default __webpack_public_path__ + "static/media/BlogView.57fd14f3737e6c190fc59ccc300055fa.svg";
export { ForwardRef as ReactComponent };